import ApiGet from "../../../../../../api-controller-mod/api-serv/get-api/getApi";
import ApiGetRealtime from "../../../../../../api-controller-mod/api-serv/get-api/getApiRealtime";
import { API_ENDPOINTS } from "../../../../../../context-controller-mod/context-serv/global-provider/api-shell/api-provider";

export interface NotificationItem {
  id: string;
  date: string;
  title: string;
  description: string;
  module: string;
}

export interface ApiNotificationMessage {
  module: string;
  message: string;
}

export interface ApiNotificationItem {
  id: number | string;
  uuid?: string;
  createdAt: string;
  message: string | ApiNotificationMessage;
  readStatus?: string;
  status?: string;
  requesterId?: string;
  approverId?: string;
  [key: string]: unknown;
}

export type NotificationApiResponse = {
  success?: boolean;
  data?: ApiNotificationItem[] | { items?: ApiNotificationItem[] };
  items?: ApiNotificationItem[];
};

export const getNotificationsApi = (page = 1, size = 10) =>
  ApiGet<NotificationApiResponse>(
    `${API_ENDPOINTS.GET_ALL_NOTIFICATIONS}?page=${page}&size=${size}`
  );

/* ── SSE ─────────────────────────────────────────────────── */

export const subscribeNotificationSSE = (
  onMessage: (item: ApiNotificationItem) => void,
  onError?: (e: unknown) => void,
): () => void =>
  ApiGetRealtime(
    API_ENDPOINTS.REAL_TIME_NOTIFICATION,
    'notification',
    (data) => onMessage(data as ApiNotificationItem),
    onError,
  );